var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconErrorRemoveCategorie = function SvgIconErrorRemoveCategorie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3m9.9 11.102a3 3 0 0 0-4.244 0L24 19.758l-5.656-5.656a3 3 0 1 0-4.242 4.242L19.757 24 14.1 29.657a3 3 0 0 0 4.242 4.243l5.656-5.657 5.657 5.657a3 3 0 0 0 4.243-4.243L28.242 24l5.657-5.656a3 3 0 0 0 0-4.242",
    clipRule: "evenodd"
  })));
};
export default SvgIconErrorRemoveCategorie;